import React from 'react';
import styled from 'styled-components';
import Modal from '../Modal';
import SalesRepSupervisorsManagementSection from './SalesRepSupervisorsManagementSection';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  salesRepId: number;
  salesRepName?: string;
}

const Wrapper = styled.div`
  direction: rtl;
`;

const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
`;

const CloseButton = styled.button`
  padding: 0.5rem 1rem;
  background: #fff;
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-md);
  font-size: 0.9rem;
  cursor: pointer;

  &:hover {
    background: #f1f3f5;
  }
`;

const SalesRepSupervisorsManagementModal: React.FC<Props> = ({ isOpen, onClose, salesRepId, salesRepName }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={salesRepName ? `ניהול המפקחים של — ${salesRepName}` : 'ניהול המפקחים של הנציג'}
      width="720px"
      maxWidth="95vw"
      footer={
        <FooterRow>
          <CloseButton onClick={onClose}>סגירה</CloseButton>
        </FooterRow>
      }
    >
      <Wrapper>
        <SalesRepSupervisorsManagementSection salesRepId={salesRepId} />
      </Wrapper>
    </Modal>
  );
};

export default SalesRepSupervisorsManagementModal;
